// removed by extract-text-webpack-plugin
module.exports = {"overlayScreen":"overlayScreen__rtNg6","otpContainer":"otpContainer__phV8w","closeIconContainer":"closeIconContainer__1P4xp","otpSection":"otpSection__3R5qK","enterOtpHeader":"enterOtpHeader__4aAok","otpVerifyContainer":"otpVerifyContainer__IdK6I","otpInputBox":"otpInputBox__15liA","otpVerifyBox":"otpVerifyBox__3TFrq","otpSubmitButton":"otpSubmitButton__3jCiL","termsContainer":"termsContainer__dyl5c"};


//////////////////
// WEBPACK FOOTER
// ./routes/program-landing-page/components/overlayScreens/style.css
// module id = Rhce
// module chunks = 446